<template>
<div class="straitigraphy-tab">
	<button @click="goToStraitigraphy()" class="button primary">
		Straitigraphy
	</button>
</div>
</template>

<script>
export default {
	methods: {
		goToStraitigraphy() {
			this.$router.push({
				name: 'straitigraphy',
				query: {
					...this.$route.query,
					opportunityId: this.$route.params.opportunityId
				}
			})
		}
	}
}
</script>

<style lang="scss">
.straitigraphy-tab {
	.button {
		font-size: 11px;
		padding: 4px 11px;
	}
}
</style>
